export const mediaPhotoStateSelector = state => state.stickers.mediaPhoto;


// WEBPACK FOOTER //
// ./src/app/modules/stickers/store/media-photo/selectors.ts